// extracted by mini-css-extract-plugin
export default {"tableWrapper":"WhatsappDashboard_tableWrapper__UL4yb"};